<template>
  <div class="user-data" v-title data-title="数据查看">
    <header>
      <div class="top-content">
        <p @click="style_btn(0)" :class="{'active-color':active_style==0}">
          全部
        </p>
        <p @click="show1 = true; style_btn(1)" :class="{'active-color':active_style==1}">
          {{identity}}<img src="../../assets/images/partner-img/partner-information/16.png" alt="">
        </p>
        <p @click="show = true; style_btn(2)" :class="{'active-color':active_style==2}">
          {{time}}<img src="../../assets/images/partner-img/partner-information/16.png" alt="">
        </p>
        <p>
          <span>
            新增收入：{{data_list.add_amount}}
          </span>
          <span>
            共计：{{data_list.all_amount}}
          </span>
        </p>
      </div>
    </header>
    <section>
      <div class="share-option-list">
        <div class="share-option-list-content" v-for="(item,index) in data_list.list" :key="index">
          <div class="touxiang">
            <img :src="item.avatar" alt="">
          </div> 
          <div class="box1">
            <p>
              {{item.good_name}}
            </p>
            <p>
              {{item.create_time}}
            </p>
          </div>
          <p class="p1">
            +{{item.brokerage}}
          </p>
        </div>
      </div>
    </section>
    <!-- 时间选择 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }" >
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="show = false"
        @confirm="confirm_btn"
      />
    </van-popup>
    <!-- 身份选择 -->
    <van-action-sheet 
      v-model="show1" 
      :actions="actions" 
      @select="onSelect" 
      :close-on-click-action="true"
    />
  </div>
</template>

<script>

import Vue from 'vue';
import { DatetimePicker, Popup, ActionSheet } from 'vant';

Vue.use(ActionSheet);
Vue.use(DatetimePicker);
Vue.use(Popup);

export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show: false,
      show1: false,
      actions: [
        { name: '消费者', id: 1}, 
        { name: '会员', id: 2 },
        { name: '商家', id: 3 }, 
        { name: '合伙人', id: 4 }
      ],
      identity: '选择身份', // 身份
      time: '本月', // 时间
      active_style: 0, // 样式
      data_list: '', // 数据列表
      search_identity: '', // 身份搜索
      search_time: '', // 时间搜索
      uid: ''
    };
  },
  created(){
    // 数据列表
    this.uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+"/api/user/index/user_data",{
      uid : this.uid,
      type : this.search_identity,
      search_time : this.search_time
    }).then((res) => {
      // console.log(res.data.data)
      this.data_list = res.data.data
    })
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    showPopup(){
      this.show = true
    },
    // 时间选择确定按钮
    confirm_btn(){
      this.time = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
      this.search_time = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
      // let uid = JSON.parse(localStorage.getItem("uid"));
      // this.$axios.post(this.domain.url+"/api/order/index/optionsList",{
      //   uid : uid,
      //   type : 2,
      //   search_time : this.search_time
      // }).then((res) => {
      //   // console.log(res)
      //   this.share_option_msg = res.data.data
      // })
      this.show = false
        this.$axios.post(this.domain.url+"/api/user/index/user_data",{
        uid : this.uid,
        type : this.search_identity,
        search_time : this.search_time
      }).then((res) => {
        // console.log(res.data.data)
        this.data_list = res.data.data
      })
    },
    // 身份选择
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.identity = item.name
      this.search_identity = item.id
      this.$axios.post(this.domain.url+"/api/user/index/user_data",{
        uid : this.uid,
        type : this.search_identity,
        search_time : this.search_time
      }).then((res) => {
        // console.log(res.data.data)
        this.data_list = res.data.data
      })
    },
    // 全部
    style_btn(index){
      this.active_style = index
      if(index == 0){
        this.identity = '选择身份', 
        this.time = '本月',
        // 数据列表
        this.$axios.post(this.domain.url+"/api/user/index/user_data",{
          uid : this.uid,
          type : '',
          search_time : ''
        }).then((res) => {
          // console.log(res.data.data)
          this.data_list = res.data.data
        })
      }
    }
  },
}
</script>

<style lang="less" scoped>
  .user-data{
    width: 7.5rem;
    header{
      width: 100%;
      height: 1.29rem;
      border-bottom: .02rem #EFEFEF solid;
      line-height: 1.29rem;
      .top-content{
        width: 100%;
        .active-color{
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FF6600;
        }
        p{
          float: left;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #222222;
            img{
              width: .09rem;
              height: .07rem;
              margin-left: .1rem;
            }
          &:nth-child(-n+3){

          }
          &:first-child{
            display: flex;
            align-items: center;
            margin-left: .4rem;
          }
          &:nth-child(2){
            display: flex;
            align-items: center;
            margin-left: .38rem;
          }
          &:nth-child(3){
            display: flex;
            align-items: center;
            margin-left: .2rem;
          }
          &:last-child{
            float: right;
            font-size: 0.24rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #A2A2A2;
            margin-top: .38rem;
            margin-right: .2rem;
            span{
              display: block;
              line-height: .35rem;
            }
          }
        }
      }
    }
    section{
      .share-option-list{
        width: 7.1rem;
        margin: 0 auto;
        background: #fff;
        .share-option-list-content{
          width: 6.85rem;
          height: 1.35rem;
          background: #fff;
          margin: 0 auto;
          border-bottom: .01rem #EDEDEF solid;
          .touxiang{
            width: .94rem;
            height: 1.35rem;
            float: left;
            margin-right: .1rem;
            display: flex;
            align-items: center;
            img{
              width: .94rem;
              height: .94rem;
              border-radius: 50%;
            }
          }
          .box1{
            // text-align: center;
            float: left;
            margin-left: .19rem;
            p{
              display: block;
              &:first-child{
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 600;
                color: #212121;
                margin-top: .35rem;
              }
              &:last-child{
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #919191;
              }
            }
          }
          .p1{
            float: right;
            font-size: 0.36rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #FF6600;
            line-height: 1.35rem;
          }
        }
      }
    }
  }
</style>